import { useParams } from 'react-router'
import { ModalCreateEditBase } from '../../../../../../../../../../baseComponents/ModalsLayouts/ModalCreateEdit'
import { FormRender } from '../../../../../../../../../../forms/FormRenderer/types'
import { OnSubmit } from '../../../../../../../../../../forms/TwinForm/types'
import useTwinTranslation from '../../../../../../../../../../utils/hooks/useTwinTranslation'
import { getVariants } from '../../../../../../../../../../utils/reducers/getters'

interface CreateAutoVariantsStep1Props {
    onSubmit: OnSubmit

}

export const CreateAutoVariantsStep1: React.FC<CreateAutoVariantsStep1Props> = ({ onSubmit }) => {
    const { id } = useParams()
    const { t } = useTwinTranslation()
    const variants = getVariants() || {}
    const fields: FormRender = [
        {
            cols: 1,
            title: t('selectTheCombinationsYouWantGenerate', 'Selecciona las combinaciones que quieres generar'),
            elements: [
                {
                    component: 'MultipleCheckboxSelector',
                    items: variants,
                    name: 'VariantGroupsId',
                    subtitles: {
                        subtitleOptions: t('variantsForSelect', 'Variantes para seleccionar'),
                        subtitleSelectedOptions: t('variantsSelected', 'Variantes seleccionadas'),
                    }
                },
                {
                    component: 'InputHidden',
                    name: 'ProductId',
                    value: id
                }
            ]
        }
    ]
    return (
        <ModalCreateEditBase url={'/api/app/product/getAllCombinationsByGroups'} onSubmit={onSubmit} translations={{ title: t('autoGeneration', 'Generación automática'), button: t('generate', 'Generar') }} haveButtonPermissions={true} fields={fields} setOpened={() => { }} triggerSuccess={false} />
    )
}